



















































import { Component } from 'vue-property-decorator';
import { CustomerStatus, CustomerType } from 'admiral-core';
import { XIcon } from 'vue-feather-icons';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { FormMixin } from '@/mixins/FormMixin';
import { BModal } from 'bootstrap-vue';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import CustomerForm, { CustomerFormModel } from '@/forms/CustomerForm.vue';
import { CustomerApi } from '@/services/CustomerApi';

@Component({
  components: {
    CustomerForm,
    FormSubmit,
    XIcon,
  },
})
export default class CreateCustomerModal extends mixins(BaseMixin, FormMixin) {
  model: CustomerFormModel = this.defaultModel();

  defaultModel(): CustomerFormModel {
    return {
      type: CustomerType.NATURAL,
      status: CustomerStatus.ACTIVE,
      email: '',
      name: '',
      salutation: undefined,
      firstname: '',
      lastname: '',
      additionalName: '',
      profession: '',
      maritalStatus: undefined,
      street: '',
      zip: '',
      city: '',
      addressSupplement: '',
      phoneLandline: '',
      phoneMobile: '',
      identifier: '',
      tags: [],
    };
  }

  /** Validiert Pflichtfelder je nach Kundentyp. */
  validateModel(): boolean {
    if (this.model.type === CustomerType.LEGAL && !this.model.name?.trim()) {
      this.addError(true, 'name', 'Bitte geben Sie einen Firmennamen an');
      return false;
    }
    if (this.model.type === CustomerType.NATURAL) {
      let valid = true;
      if (!this.model.firstname?.trim()) {
        this.addError(true, 'firstname', 'Bitte geben Sie einen Vornamen an');
        valid = false;
      }
      if (!this.model.lastname?.trim()) {
        this.addError(true, 'lastname', 'Bitte geben Sie einen Nachnamen an');
        valid = false;
      }
      return valid;
    }
    return true;
  }

  async ok(evt: Event) {
    evt.preventDefault();

    try {
      this.isLoading = true;
      this.resetErrors();

      if (!this.validateModel()) {
        return;
      }

      await CustomerApi.create({
        agency: this.agency,
        type: this.model.type,
        status: this.model.status,
        email: this.model.email,
        name: this.model.name,
        salutation: this.model.salutation,
        firstname: this.model.firstname,
        lastname: this.model.lastname,
        additionalName: this.model.additionalName,
        title: this.model.title,
        gender: this.model.gender,
        maritalStatus: this.model.maritalStatus,
        profession: this.model.profession,
        street: this.model.street,
        zip: this.model.zip,
        city: this.model.city,
        addressSupplement: this.model.addressSupplement,
        phoneLandline: this.model.phoneLandline,
        phoneMobile: this.model.phoneMobile,
        identifier: this.model.identifier,
        birthDate:
          this.model.type === CustomerType.NATURAL ? this.model.birthDate : undefined,
        contactPerson:
          this.model.type === CustomerType.LEGAL
            ? this.model.contactPerson?.trim() || undefined
            : undefined,
        userId: this.model.user?.id,
        tags: this.model.tags || [],
      });

      this.$toastr.s('Kunde erfolgreich angelegt.', 'Kunde angelegt');
      this.model = this.defaultModel();
      this.$emit('reload');
      this.$nextTick(() => {
        (this.$refs['create-customer'] as BModal).hide();
      });
    } catch (e) {
      console.log(e);
      this.$toastr.e('Beim Speichern des Kunden ist etwas schief gelaufen.');
    } finally {
      this.isLoading = false;
    }
  }

  cancel() {
    this.model = this.defaultModel();
    this.errors = {};
    (this.$refs['create-customer'] as BModal).hide();
  }
}
